export enum Season {
    Spring = 'spring',
    Summer = 'summer',
    Autumn = 'autumn',
    Winter = 'winter'
}